import axios from "axios";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { apiURI, authErrorRedirect } from "../common";
import { UserProfileForm } from "./";

export function CreateUser() {
  const history = useNavigate();

  const [errors, setErrors] = useState({});
  const [organization, setOrganization] = useState("");
  const [department, setDepartment] = useState("");
  const [role, setRole] = useState("");
  const [organizationsList, setOrganizationsList] = useState([]);
  const [departmentsList, setDepartmentsList] = useState([]);

  const handleChangeDepartment = (event) => {
    setDepartment(event.target.value);
  };

  // Function to handle organization selection
  const handleChangeOrganization = (event) => {
    setOrganization(event.target.value);
    // Find the selected organization
    const selectedOrganization = organizationsList.find(
      (org) => org.name === event.target.value
    );
    setDepartmentsList(selectedOrganization.departments);
  };
  const handleChangeRole = (event) => {
    setRole(event.target.value);
  };

  useEffect(() => {
    axios
      .get(`${apiURI}/form/getOrganizationsList`)
      .then(async (response) => {
        setOrganizationsList(response.data);
      })
      .catch((response) => {
        console.log("error in axios form call react");
        setErrors({});
        setErrors(response.response.data);
        authErrorRedirect(response.response.data, history);
      });
    // eslint-disable-next-line no-console
  }, []);

  const handleSubmit = (event) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);

    const newUser = {
      userID: data.get("username"),
      firstName: data.get("firstName"),
      lastName: data.get("lastName"),
      organization: organization,
      department: department,
      email: data.get("email"),
      role: role,
    };

    axios
      .post(`${apiURI}/auth/register`, newUser)
      .then(() => {
        history("/users");
      })
      .catch((response) => {
        console.log(
          "error in axios register call react:",
          response.response.data
        );
        setErrors({});
        setErrors(response.response.data);
        authErrorRedirect(response.response.data, history);
      });
    // eslint-disable-next-line no-console
  };
  return (
    <UserProfileForm
      organizationsList={organizationsList}
      departmentsList={departmentsList}
      errors={errors}
      department={department}
      organization={organization}
      role={role}
      handleChangeDepartment={handleChangeDepartment}
      handleChangeOrganization={handleChangeOrganization}
      handleChangeRole={handleChangeRole}
      handleSubmit={handleSubmit}
    ></UserProfileForm>
  );
}
